module.exports = __webpack_public_path__ + "static/media/menu-icon-close.16354f00.svg";